var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69275 3.06999L0.0485242 8.00267C0.0160354 8.10013 0 8.20276 0 8.30501V9.10566C0 9.61072 0.392486 10.0247 0.888889 10.0589C0.909467 10.0603 0.930223 10.0611 0.951137 10.0612C0.952609 10.0612 0.954081 10.0612 0.955555 10.0612V14.839C0.955607 15.3667 1.38339 15.7945 1.91111 15.7945H9.55555C10.0833 15.7945 10.511 15.3667 10.5111 14.839V10.0612H14.8216V15.1229C14.8215 15.1296 14.8216 15.1363 14.8217 15.143C14.8306 15.4801 15.1806 15.7945 15.5217 15.7945C15.8628 15.7945 16.2345 15.4801 16.2443 15.143C16.2445 15.1363 16.2445 15.1296 16.2444 15.1229V10.0612C16.2704 10.0612 16.2961 10.0602 16.3216 10.0581C16.813 10.0188 17.2 9.60715 17.2 9.10566V8.30501C17.2 8.20276 17.1839 8.10013 17.1515 8.00267L15.5072 3.06999C15.3773 2.67917 15.012 2.41678 14.6002 2.41678H2.59978C2.18794 2.41678 1.82271 2.67917 1.69275 3.06999ZM14.7444 8.56121H15.7V8.39165L14.2084 3.91678H2.99163L1.5 8.39166V8.5612M14.7444 8.56121H10.5778H14.7444ZM9.07777 10.0612L2.38889 10.0612V14.3612H9.07777V10.0612Z",
    fill: "#323F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.75C2 0.335786 2.33579 0 2.75 0H14.75C15.1642 0 15.5 0.335786 15.5 0.75C15.5 1.16421 15.1642 1.5 14.75 1.5H2.75C2.33579 1.5 2 1.16421 2 0.75Z",
    fill: "#323F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.22b70f8327e56bbd63e5e103e882e0a4.svg";
export { ForwardRef as ReactComponent };